<template>
<div>
  <a-tabs type="card" v-model="activeKey">
    <a-tab-pane v-for="(item) of tabList" :key="item.key" :tab="item.title">
      <x-order v-if="activeKey === item.key" :activeKey="activeKey"></x-order>
    </a-tab-pane>
  </a-tabs>

</div>
</template>

<script>
import order from '@/components/package/order.vue';
export default {
  components: {
    xOrder: order
  },
  name: 'order',
  data () {
    return {
      activeKey: 'nonpay',
      tabList: [
        { title: '待付款', key: 'nonpay' },
        { title: '待审核', key: 'nonAudit' },
        { title: '审核通过', key: 'pass' },
        { title: '已关闭', key: 'closed' },
        { title: '退款/售后', key: 'service' }
      ]
    };
  },
  created () {},
  methods: {
  }
};
</script>
